import type { Docs } from '../../api/responses/docs-response.dto'

export interface PaginatedData<T> {
  items: T[]
  page: number
  totalDocs: number
  totalPages: number
}

export function mapToPaginatedData<T>(docs: Docs<T>): PaginatedData<T> {
  return {
    items: docs.docs,
    page: docs.page ?? 1,
    totalDocs: docs.totalDocs ?? 0,
    totalPages: docs.totalPages ?? 1,
  }
}
